/**
 * Auth API service
 * Replace MOCK_USERS with a real POST /auth/login call when backend is ready.
 */
import httpClient from './httpClient'

// ─── MOCK credentials (remove when backend is ready) ───────────────────────
// const MOCK_USERS = [
//   {
//     id:    'u-001',
//     email: 'admin@test.com',
//     password: 'Admin123',
//     name:  'Admin User',
//     role:  'ADMIN',
//     token: 'mock-jwt-token-admin-001',
//   },
//   {
//     id:    'u-002',
//     email: 'viewer@test.com',
//     password: 'Viewer123',
//     name:  'Viewer User',
//     role:  'VIEWER',
//     token: 'mock-jwt-token-viewer-002',
//   },
// ]

const USE_MOCK = false   // ← flip to false when backend is ready

// ─── Auth API ────────────────────────────────────────────────────────────────

/**
 * Login
 * @param {string} email
 * @param {string} password
 * @returns {Promise<{id, email, name, role, token}>}
 */
// export async function loginApi(email, password) {
//   if (USE_MOCK) {
//     await new Promise((r) => setTimeout(r, 600))   // simulate latency
//     const user = MOCK_USERS.find(
//       (u) => u.email === email && u.password === password
//     )
//     if (!user) throw { status: 401, message: 'Invalid email or password' }
//     const { password: _, ...safeUser } = user
//     return safeUser
//   }

//   // Real API call — uncomment when backend is ready:
//   // const { data } = await httpClient.post('/auth/login', { email, password })
//    return  { id:"1", email:"admin@test.com", name:"Admin", role:"ADMIN", token: "token1234"}  //expects: { id, email, name, role, token }
// }
export async function loginApi(email, password) {

  if (USE_MOCK) {
    await new Promise((r) => setTimeout(r, 600))

    const user = MOCK_USERS.find(
      (u) => u.email === email && u.password === password
    )

    if (!user) {
      throw { status: 401, message: 'Invalid email or password' }
    }

    const { password: _, ...safeUser } = user
    return safeUser
  }

  const { data } = await httpClient.post(
    '/auth/login',
    {
      email,
      password,
    }
  )

  return {
    id: '1',
    email: data.email,
    name: data.email,
    role: data.role,
    token: data.token,
  }
}
/**
 * Logout (call backend to invalidate token if needed)
 */
export async function logoutApi() {
  if (USE_MOCK) return

  // await httpClient.post('/auth/logout')
}

/**
 * Refresh token (optional — wire into httpClient 401 retry logic)
 */
export async function refreshTokenApi() {
  if (USE_MOCK) return null

  // const { data } = await httpClient.post('/auth/refresh')
  // return data.token
}
